export default "__VITE_ASSET__Cs2jrsvF__"